import { render, staticRenderFns } from "./CallCenterInvoiceDiscountingListComponent.vue?vue&type=template&id=63deef8d&"
import script from "./CallCenterInvoiceDiscountingListComponent.vue?vue&type=script&lang=js&"
export * from "./CallCenterInvoiceDiscountingListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports